import { render, staticRenderFns } from "./ImgContentOne.vue?vue&type=template&id=68095a54&scoped=true&"
var script = {}
import style0 from "./ImgContentOne.vue?vue&type=style&index=0&id=68095a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68095a54",
  null
  
)

export default component.exports